/** Keeps the dragged row inside its list and on the vertical axis. */
export function restrictToParent({ transform, draggingNodeRect, containerNodeRect }) {
  const next = { ...transform, x: 0 };
  if (!draggingNodeRect || !containerNodeRect) return next;
  const minY = containerNodeRect.top - draggingNodeRect.top;
  const maxY = containerNodeRect.bottom - draggingNodeRect.bottom;
  next.y = Math.min(Math.max(next.y, minY), maxY);
  return next;
}
